import { z } from 'zod';
import { MapEntity, mapEntitySchema } from 'app/agriculture/queries/types/geometry/MapEntity';
import {
    mockLineStringGeometry,
    LineStringGeometry,
    lineStringGeometrySchema,
} from 'app/agriculture/queries/types/geometry/LineStringGeometry';
import {
    FenceType,
    fenceTypeSchema,
} from 'app/agriculture/queries/entities/types/infrastructure/FenceType';

export interface Fence extends MapEntity {
    id: string;

    creatorId: number;
    createdAt: Date;
    updatedAt: Date;

    name: string;
    fenceType: FenceType;

    geometry: LineStringGeometry;
}

export const fenceSchema = mapEntitySchema.extend({
    id: z.string().uuid(),

    creatorId: z.number(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),

    name: z.string(),
    fenceType: fenceTypeSchema,

    geometry: lineStringGeometrySchema,
});

export const mockFence = ({
    id = 'fcd38366-0ac4-4a09-b0b3-6315cf5c67ab',

    creatorId = 1,
    createdAt = new Date(),
    updatedAt = new Date(),

    name = 'Mock Fence Name',
    fenceType = 'Plain Wire',

    geometry = mockLineStringGeometry(),
}: Partial<Fence> = {}): Fence => ({
    id,

    creatorId,
    createdAt,
    updatedAt,

    name,
    fenceType,

    geometry,
});
